import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FC, ReactNode } from 'react';
import Button from '../../button';
import useModal from '../../../hooks/use-modal.hook';
import Modal from '..';

interface Props {
  title?: string;
  content: ReactNode;
  variant?: 'default' | 'delete';
  onClose: (confirm?: boolean) => void;
}

export const ConfirmModal: FC<Props> = ({
  title = 'Confirm',
  content,
  variant = 'default',
  onClose,
}) => {
  const { closeModal } = useModal();

  const isDelete = variant === 'delete';

  const handleClose = (confirm?: boolean) => {
    onClose(confirm);
    closeModal();
  };

  return (
    <Modal>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button label="Cancel" type="cancel" onClick={() => handleClose(false)} />
        <Button
          label={isDelete ? 'Delete' : 'Confirm'}
          type={isDelete ? 'delete' : 'ok'}
          onClick={() => handleClose(true)}
        />
      </DialogActions>
    </Modal>
  );
};

export default ConfirmModal;
